import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ProjectRouteStation } from '../../shared/interfaces/project-route-station.interface';
import { ProjectGroupMetaInformation } from '../../shared/interfaces/project-group-meta-information';
import { timerTypeBlocks } from '../shared/time-switch-component-types';

export interface AssignmentConflictRow {
  name: string;
  types: string[];
  station?: ProjectRouteStation;
  metaInformation?: ProjectGroupMetaInformation[];
}

export interface AssignmentConflictDialogData {
  rows: AssignmentConflictRow[];
}

/**
 * Zeigt die bei der Zuweisung nicht gesetzten Stationen/Typen tabellarisch an
 * (Kanal gehört bereits einer anderen Zeitschaltuhr). Modal, mit OK zu bestätigen.
 */
@Component({
  selector: 'avs-assignment-conflict-dialog',
  standalone: false,
  templateUrl: './assignment-conflict-dialog.component.html',
  styleUrls: ['./assignment-conflict-dialog.component.css']
})
export class AssignmentConflictDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: AssignmentConflictDialogData,
    public dialogRef: MatDialogRef<AssignmentConflictDialogComponent>
  ) { }

  public typeBlocks(types: string[]): { label: string, color: string, text: string }[] {
    return timerTypeBlocks(types ?? []);
  }

  public onClose(): void {
    this.dialogRef.close();
  }
}
